import { useQuery } from '@tanstack/react-query';

import backendService from '../services/backendService';

export type ReportInsightType =
  | 'learningObjective'
  | 'lessonSummary'
  | 'studentSummary'
  | 'whoNeedsHelp'
  | 'whoDidGreat';
export type ReportInsight = {
  id: string;
  livePresentationId: string;
  type: string;
  promptOutput: string;
  tenantId: string;
  modifiedAt: Date;
  participantId: string | null;
};

const useReportInsights = ({
  reportType,
  livePresentationId,
  participantId,
  reportIsApprovedForInsight,
}: {
  reportType: ReportInsightType;
  livePresentationId: string;
  participantId?: string;
  reportIsApprovedForInsight?: boolean;
}) => {
  const { data, isFetching, error } = useQuery({
    queryKey: ['report-insight', reportType, livePresentationId, participantId || ''],

    queryFn: () => {
      if (participantId) {
        return backendService.instance.ai.getParticipantInsights({
          reportType,
          livePresentationId,
          participantId,
        });
      }
      return backendService.instance.ai.getInsights({
        reportType,
        livePresentationId,
      });
    },

    enabled: reportIsApprovedForInsight,
    staleTime: 1000 * 60 * 60 * 5,
    retry: 0
  });

  return {
    data,
    isFetching,
    error,
  };
};

export default useReportInsights;
